import { combineReducers } from 'redux';

import type { Section } from 'models';

import { FETCH_OFFER_SUCCESS } from '../../../../constants';

type OffersAction = {
  type: typeof FETCH_OFFER_SUCCESS;
  payload: {
    entities: {
      sections: Record<string, Section>;
    };
  };
};

export const byId = (
  state: Record<string, Section> = {},
  action: OffersAction,
) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
      const {
        entities: { sections = {} },
      } = action.payload;
      return sections;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: OffersAction) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
      const {
        entities: { sections = {} },
      } = action.payload;
      return Object.keys(sections);
    default:
      return state;
  }
};

const offers = combineReducers({ byId, ids });

export { offers };
